import { type FC } from 'react';

interface Props {
  title?: string;
  message?: string;
}

const ErrorMessage: FC<Props> = ({ message = 'Something went wrong', title = 'Error Found' }) => {
  return (
    <div className={'hc:flex hc:flex-col hc:h-full hc:w-full hc:items-center hc:justify-center'}>
      <h1 className={'hc:text-cardinal-700 hc:text-xl hc:font-black'}>{title}</h1>
      <p className={'hc:text-white-700 hc:text-lg hc:font-500'}>{message}</p>
    </div>
  );
};
export default ErrorMessage;
